export const clickOutside = {
  mounted(el, binding) {
    document.addEventListener('click', (event) => {
      if (!el.contains(event.target)) {
        if (typeof binding.value === 'function')
          binding.value()
      }
    })
  }
}

